import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import ru from "./ru.json";

export const LANGUAGES = ["en", "ru"] as const;
export type Language = (typeof LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    // Default to English: we only ever read a stored choice, never the browser
    // locale, so a fresh visitor gets `fallbackLng`.
    fallbackLng: "en",
    supportedLngs: LANGUAGES,
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "nm_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

/** Translate a backend status string, falling back to a spaced form. */
export function tStatus(value: string | null | undefined): string {
  if (!value) return "—";
  return i18n.t(`status.${value}`, {
    defaultValue: value.replace(/_/g, " "),
  });
}

/** A booking line's service kind, capitalised like the other services. Its own
 * dictionary (`serviceKinds.*`), because some kinds share a `status.*` key with a
 * lowercase meaning elsewhere — `guide` is also the driver type «гид». */
export function tServiceKind(value: string | null | undefined): string {
  if (!value) return "—";
  return i18n.t(`serviceKinds.${value}`, { defaultValue: tStatus(value) });
}

export default i18n;
